var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7321 10.6614L13.4478 0.587282C13.0623 0.2082 12.5483 0 12.0002 0C11.4522 0 10.9382 0.2082 10.5526 0.587282L0.268352 10.6614C0.0944901 10.8323 0 11.0562 0 11.2978C0 11.5394 0.0963798 11.7633 0.268352 11.9342C0.625524 12.2838 1.20758 12.2838 1.56665 11.9342L2.64005 10.8834V21.4564C2.64005 22.8588 3.80417 24 5.23664 24H18.4974C19.9298 24 21.094 22.8588 21.094 21.4564V10.6182L22.4357 11.9342C22.6058 12.1012 22.842 12.1974 23.0839 12.1974C23.3258 12.1974 23.562 12.1012 23.7321 11.9342C24.0893 11.5846 24.0893 11.013 23.7321 10.6634V10.6614ZM19.2571 8.82102V21.4564C19.2571 21.8689 18.915 22.2028 18.4955 22.2028H5.23664C4.8171 22.2028 4.47694 21.8689 4.47694 21.4564V9.08225L11.8509 1.85809C11.8906 1.81881 11.9435 1.7972 12.0002 1.7972C12.0569 1.7972 12.1098 1.81881 12.1495 1.85809L19.2571 8.82102Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4be0e955321ece75bb6a822087f61df6.svg";
export { ForwardRef as ReactComponent };